"use strict";
exports.__esModule = true;
exports.NftService = void 0;
var tslib_1 = require("tslib");
var types_1 = require("./types");
var constants_1 = require("@ethersproject/constants");
var nft_provider_1 = require("./nft.provider");
var ethers_1 = require("ethers");
var typechain_types_1 = require("../../typechain-types");
var transaction_service_1 = require("../transaction/transaction.service");
var chain_provider_1 = require("../factory/chain-provider");
var utils_1 = require("../common/utils");
var constants_2 = require("../common/constants");
var gelato_1 = require("../gasless-providers/gelato");
var NftService = /** @class */ (function () {
    function NftService() {
    }
    // Get all the NFTs owned by an address
    NftService.getNfts = function (owner, chainID, contractAddresses) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, nft_provider_1.NftProvider.getNfts(owner, chainID, contractAddresses)];
            });
        });
    };
    // Gets all Nfts minted from a contract. 
    // use the pageKey( returned with each response ) to request the next page of nfts
    // pageSize is 100 by default
    NftService.getNftsForContract = function (contractAddress, chainID, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, nft_provider_1.NftProvider.getNftsForContract(contractAddress, chainID, options)];
            });
        });
    };
    NftService.transferNft = function (transferRequest, chainId, pkOrProvider, isGasless) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contractAddress, receiver, tokenIDs, amounts, wallet, owner, tx, data, contract, _contract, contract, _contract, preparedTx;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, utils_1.getChainID)(pkOrProvider, chainId)];
                    case 1:
                        chainId = _a.sent();
                        contractAddress = transferRequest.contractAddress, receiver = transferRequest.receiver, tokenIDs = transferRequest.tokenIDs, amounts = transferRequest.amounts;
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 2:
                        wallet = _a.sent();
                        return [4 /*yield*/, wallet.getAddress()];
                    case 3:
                        owner = _a.sent();
                        data = "0x";
                        if (!!amounts) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.cacheGet(contractAddress, chainId, types_1.NftType.ERC721)];
                    case 4:
                        contract = (_a.sent()).contract;
                        _contract = contract;
                        return [4 /*yield*/, _contract.populateTransaction["safeTransferFrom(address,address,uint256)"](owner, receiver, tokenIDs[0])];
                    case 5:
                        tx = _a.sent();
                        return [3 /*break*/, 11];
                    case 6: return [4 /*yield*/, this.cacheGet(contractAddress, chainId, types_1.NftType.ERC1155)];
                    case 7:
                        contract = (_a.sent()).contract;
                        _contract = contract;
                        if (!(tokenIDs.length > 1)) return [3 /*break*/, 9];
                        return [4 /*yield*/, _contract.populateTransaction.safeBatchTransferFrom(owner, receiver, tokenIDs, amounts, data)];
                    case 8:
                        tx = _a.sent();
                        return [3 /*break*/, 11];
                    case 9: return [4 /*yield*/, _contract.populateTransaction.safeTransferFrom(owner, receiver, tokenIDs[0], amounts[0], data)];
                    case 10:
                        tx = _a.sent();
                        _a.label = 11;
                    case 11:
                        if (isGasless)
                            return [2 /*return*/, gelato_1.Gelato.sendTx(chainId, contractAddress, owner, tx.data, pkOrProvider)];
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction(tslib_1.__assign(tslib_1.__assign({}, tx), { from: owner, chainId: chainId }), chainId)];
                    case 12:
                        preparedTx = _a.sent();
                        return [4 /*yield*/, wallet.sendTransaction(preparedTx)];
                    case 13: return [2 /*return*/, (_a.sent()).hash];
                }
            });
        });
    };
    NftService.cacheGet = function (contractAddress, chainID, nftType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contractFactory, _a, _b, _c, _d, _e;
            var _f;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (NftService.cache[contractAddress]) {
                            return [2 /*return*/, NftService.cache[contractAddress]];
                        }
                        if (!!nftType) return [3 /*break*/, 2];
                        return [4 /*yield*/, nft_provider_1.NftProvider.getNftType(contractAddress, chainID)];
                    case 1:
                        nftType = _g.sent();
                        _g.label = 2;
                    case 2:
                        if (!(nftType !== types_1.NftType.UNKNOWN)) return [3 /*break*/, 4];
                        contractFactory = nftType == types_1.NftType.ERC1155 ? typechain_types_1.LiqERC1155__factory : typechain_types_1.LiqERC721__factory;
                        _a = NftService.cache;
                        _b = contractAddress;
                        _f = {};
                        _d = (_c = contractFactory)
                            .connect;
                        _e = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainID)];
                    case 3:
                        _a[_b] = (_f.contract = _d.apply(_c, _e.concat([_g.sent()]))
                            .attach(contractAddress),
                            _f.schema = nftType,
                            _f);
                        return [2 /*return*/, NftService.cache[contractAddress]];
                    case 4: throw new Error("".concat(contractAddress, " is not an NFT contract"));
                }
            });
        });
    };
    NftService.createERC1155Collection = function (_a, chainId, pkOrProvider, isGaslessCompliant) {
        var _b;
        var uri = _a.uri;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var wallet, owner, contractFactory, args, tx, preparedTx;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, (0, utils_1.getChainID)(pkOrProvider, chainId)];
                    case 1:
                        chainId = _c.sent();
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 2:
                        wallet = _c.sent();
                        return [4 /*yield*/, wallet.getAddress()];
                    case 3:
                        owner = _c.sent();
                        args = [uri];
                        if (isGaslessCompliant) {
                            if (!constants_2.GELATO_SUPPORTED_NETWORKS.includes(chainId))
                                throw ("Cannot deploy gasless compliant contract on the chain. not supported by us now");
                            contractFactory = new ethers_1.ethers.ContractFactory(typechain_types_1.LiqERC1155Meta__factory.abi, typechain_types_1.LiqERC1155Meta__factory.bytecode, wallet);
                            args.push(constants_2.GELATO_RELAY_ADDRESS);
                        }
                        else {
                            contractFactory = new ethers_1.ethers.ContractFactory(typechain_types_1.LiqERC1155__factory.abi, typechain_types_1.LiqERC1155__factory.bytecode, wallet);
                        }
                        tx = contractFactory.getDeployTransaction.apply(contractFactory, args);
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction({
                                from: owner,
                                to: undefined,
                                data: (_b = tx.data) === null || _b === void 0 ? void 0 : _b.toString(),
                                chainId: chainId
                            }, chainId)];
                    case 4:
                        preparedTx = _c.sent();
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 5: return [4 /*yield*/, (_c.sent()).sendTransaction(preparedTx)];
                    case 6: return [2 /*return*/, (_c.sent()).hash];
                }
            });
        });
    };
    NftService.mintERC1155Token = function (_a, chainId, pkOrProvider, isGasless) {
        var contractAddress = _a.contractAddress, recipient = _a.recipient, id = _a.id, amount = _a.amount;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contract, _b, _c, _d, wallet, owner, data, tx, preparedTx;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, (0, utils_1.getChainID)(pkOrProvider, chainId)];
                    case 1:
                        chainId = _e.sent();
                        _c = (_b = typechain_types_1.LiqERC1155__factory).connect;
                        _d = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainId)];
                    case 2:
                        contract = _c.apply(_b, _d.concat([_e.sent()])).attach(contractAddress);
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 3:
                        wallet = _e.sent();
                        return [4 /*yield*/, wallet.getAddress()];
                    case 4:
                        owner = _e.sent();
                        data = "0x";
                        return [4 /*yield*/, contract.populateTransaction.mint(recipient, id, amount, data)];
                    case 5:
                        tx = _e.sent();
                        if (isGasless)
                            return [2 /*return*/, gelato_1.Gelato.sendTx(chainId, contractAddress, owner, tx.data, pkOrProvider)];
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction(tslib_1.__assign(tslib_1.__assign({}, tx), { from: owner, chainId: chainId }), chainId)];
                    case 6:
                        preparedTx = _e.sent();
                        return [4 /*yield*/, wallet.sendTransaction(preparedTx)];
                    case 7: return [2 /*return*/, (_e.sent()).hash];
                }
            });
        });
    };
    NftService.createERC721Collection = function (_a, chainId, pkOrProvider, isGaslessCompliant) {
        var _b;
        var tokenName = _a.tokenName, tokenSymbol = _a.tokenSymbol;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var wallet, owner, contractFactory, args, tx, preparedTx;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, (0, utils_1.getChainID)(pkOrProvider, chainId)];
                    case 1:
                        chainId = _c.sent();
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 2:
                        wallet = _c.sent();
                        return [4 /*yield*/, wallet.getAddress()];
                    case 3:
                        owner = _c.sent();
                        args = [tokenName, tokenSymbol];
                        if (isGaslessCompliant) {
                            if (!constants_2.GELATO_SUPPORTED_NETWORKS.includes(chainId))
                                throw ("Cannot deploy gasless compliant contract on the chain. not supported by us now");
                            contractFactory = new ethers_1.ethers.ContractFactory(typechain_types_1.LiqERC721Meta__factory.abi, typechain_types_1.LiqERC721Meta__factory.bytecode, wallet);
                            args.push(constants_2.GELATO_RELAY_ADDRESS);
                        }
                        else {
                            contractFactory = new ethers_1.ethers.ContractFactory(typechain_types_1.LiqERC721__factory.abi, typechain_types_1.LiqERC721__factory.bytecode, wallet);
                        }
                        tx = contractFactory.getDeployTransaction.apply(contractFactory, args);
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction({
                                from: owner,
                                to: undefined,
                                data: (_b = tx.data) === null || _b === void 0 ? void 0 : _b.toString(),
                                chainId: chainId
                            }, chainId)];
                    case 4:
                        preparedTx = _c.sent();
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 5: return [4 /*yield*/, (_c.sent()).sendTransaction(preparedTx)];
                    case 6: return [2 /*return*/, (_c.sent()).hash];
                }
            });
        });
    };
    NftService.mintERC721Token = function (_a, chainId, pkOrProvider, isGasless) {
        var contractAddress = _a.contractAddress, recipient = _a.recipient, uri = _a.uri;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contract, _b, _c, _d, wallet, owner, tx, preparedTx;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, (0, utils_1.getChainID)(pkOrProvider, chainId)];
                    case 1:
                        chainId = _e.sent();
                        _c = (_b = typechain_types_1.LiqERC721__factory).connect;
                        _d = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainId)];
                    case 2:
                        contract = _c.apply(_b, _d.concat([_e.sent()])).attach(contractAddress);
                        return [4 /*yield*/, (0, utils_1.getWallet)(pkOrProvider, chainId)];
                    case 3:
                        wallet = _e.sent();
                        return [4 /*yield*/, wallet.getAddress()];
                    case 4:
                        owner = _e.sent();
                        return [4 /*yield*/, contract.populateTransaction.safeMint(recipient, uri)];
                    case 5:
                        tx = _e.sent();
                        if (isGasless)
                            return [2 /*return*/, gelato_1.Gelato.sendTx(chainId, contractAddress, owner, tx.data, pkOrProvider)];
                        return [4 /*yield*/, transaction_service_1.TransactionService.prepareTransaction(tslib_1.__assign(tslib_1.__assign({}, tx), { from: owner, chainId: chainId }), chainId)];
                    case 6:
                        preparedTx = _e.sent();
                        return [4 /*yield*/, wallet.sendTransaction(preparedTx)];
                    case 7: return [2 /*return*/, (_e.sent()).hash];
                }
            });
        });
    };
    NftService.isApprovedForAll = function (contractAddress, owner, operator, chainId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contract, _a, _b, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = typechain_types_1.LiqERC721__factory).connect;
                        _c = [constants_1.AddressZero];
                        return [4 /*yield*/, (0, chain_provider_1.getChainProvider)(chainId)];
                    case 1:
                        contract = _b.apply(_a, _c.concat([_d.sent()])).attach(contractAddress);
                        return [2 /*return*/, contract.isApprovedForAll(owner, operator)];
                }
            });
        });
    };
    NftService.cache = {};
    return NftService;
}());
exports.NftService = NftService;
